'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

// -----------------------------------
// Tween search
// -----------------------------------

function tweenComparator(a, b, time) {
  if (a.stop <= time && time < b.stop) {
    return 0;
  } else {
    if (time < a.stop) {
      return -1;
    } else {
      return 1;
    }
  }
}

function tweenSearch(sortedList, time, low, high, comparator) {
  var mid = Math.floor(low + (high - low) / 2);
  var len = sortedList.length;

  if (len == 0) return null;
  if (mid < 0) return [sortedList[0]];
  if (mid == len - 1) return [sortedList[len - 1]];

  var a = sortedList[mid];
  var b = sortedList[mid + 1];

  var result = comparator(a, b, time);

  if (result == 0) {
    return [a, b];
  } else {
    if (result < 0) {
      return tweenSearch(sortedList, time, low, mid - 1, comparator);
    } else {
      return tweenSearch(sortedList, time, mid + 1, high, comparator);
    }
  }
}

// -----------------------------------
// Keyframe interpolation
// -----------------------------------

function timingToInterpFn(timing, lib) {
  var map = {
    'linear': lib.linearInterpolate,
    'smooth': lib.smoothInterpolate
  };
  return map[timing] || map.linear;
}

function _keyframeInterpolate(keyframes, time, timing, lib) {

  if (!Array.isArray(keyframes) || !keyframes.length) {
    return lib.zero();
  }

  var result = search.tween(keyframes, time);
  var interpolate = timingToInterpFn(timing, lib);

  if (result.length == 1) {
    var value = result[0].value;
    return interpolate(value, value, 0);
  }

  var _result = _slicedToArray(result, 2),
      a = _result[0],
      b = _result[1];

  var t_segment = (time - a.stop) / (b.stop - a.stop);
  return interpolate(a.value, b.value, t_segment);
}

// -------------------------------------------------
// search library
// -------------------------------------------------

var search = {

  /**
   * Find the keyframe or keyframe pair closest to a given time
   * @param {keyframe[]} sortedList a list of keyframes sorted
   * by 'stop', e.g, [{stop: 0.1}, {stop: 0.3}, {stop: 0.5}]
   * @param {number} time the time nearest to the desired keyframe
   * or keyframe pair
   * @param {function} comparator the search comparator function, e.g.,
   * (candidate:keyframe, target:keyframe) => number
   */
  tween: function tween(sortedList, time) {
    var comparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : tweenComparator;

    return tweenSearch(sortedList, time, 0, sortedList.length - 1, comparator);
  }
};

// -------------------------------------------------
// util library
// -------------------------------------------------

var util = {

  /**
   * Smooth a parameter in the range 0 <= t <= 1 in a manner
   * that approximates cosine.
   * @param {float} t interpolation parameter in the range [0, 1]
   * @returns {float}
   */
  smooth: function smooth(t) {
    return 3 * Math.pow(t, 2) - 2 * Math.pow(t, 3);
  },


  /**
   * Convert a 3d byte vector to a hex color string,
   * e.g, [0, 127, 255] -> #007fff
   * @param {number[]} vector a three-element array
   * @returns {string}
   */
  vector3dToHex: function vector3dToHex(vector) {
    var hexColor = '#' + vector.slice(0, 3).map(function (c) {
      var byte = Math.round(c);
      var hex = byte.toString(16);
      return hex.length == 1 ? '0' + hex : hex;
    }).join('');

    return hexColor;
  },


  /**
   * Convert a hex color string to a 3d byte vector,
   * e.g, #007fff -> [0, 127, 255]
   * @param {string} hexColor
   * @returns {number[]}
   */
  hexToVector3d: function hexToVector3d(hexColor) {
    var hex = hexColor.slice(1);
    var r = parseInt(hex.slice(0, 2), 16);
    var g = parseInt(hex.slice(2, 4), 16);
    var b = parseInt(hex.slice(4, 6), 16);
    return [r, g, b];
  },


  /**
   * Convert a 3d byte vector to an rgb color string,
   * e.g., [0, 127, 255] -> 'rgb(0,127,255)'
   * @param {number[]}
   * @returns {string}
   */
  vector3dToRgb: function vector3dToRgb(vector) {
    vector = vector.slice(0, 3).map(function (byte) {
      return Math.round(byte);
    });
    return 'rgb(' + vector + ')';
  },


  /**
   * Convert an rgb color string to a 3d byte vector,
   * e.g., 'rgb(0,127,255)' -> [0, 127, 255]
   * @param {string} rgbColor
   * @returns {number[]}
   */
  rgbToVector3d: function rgbToVector3d(rgbColor) {
    var list = rgbColor.split(/[(), ]+/);
    return list.slice(1, 4).map(function (s) {
      return +s;
    });
  },


  /**
   * Sort a list of keyframes in place, or any list of objects
   * with a numerical 'stop' property
   * @param {keyframe[]} keyframes a list of keyframes in
   * the form, e.g.,  [{stop: 0.5}, {stop: 0.1}, {stop: 0.95}]
   * @returns {keyframe[]}
   */
  keyframeSort: function keyframeSort(keyframes) {
    return keyframes.sort(function (a, b) {
      return a.stop - b.stop;
    });
  }
};

// -------------------------------------------------
// scalar library
// -------------------------------------------------

var scalar = {

  /**
   * Return zero
   * @returns {number}
   */
  zero: function zero() {
    return 0;
  },


  /**
   * Interpolate between a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    return a + t * (b - a);
  },


  /**
   * Interpolate between a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    return a + util.smooth(t) * (b - a);
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [{stop: 0.1, value: 10}, {stop: 0.5, value: 20}, {stop: 0.9, value: 30}]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : scalar;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

// -------------------------------------------------
// vector2d library
// -------------------------------------------------

var vector2d = {

  /**
   * Return the zero vector
   */
  zero: function zero() {
    return [0, 0];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    var lerp = scalar.linearInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t)];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    var lerp = scalar.smoothInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t)];
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [
   *   {stop: 0.1, value: [0, 100]},
   *   {stop: 0.5, value: [100, 100]},
   *   {stop: 0.9, value: [100, 0]}
   * ]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : vector2d;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

// -------------------------------------------------
// vector3d library
// -------------------------------------------------

var vector3d = {

  /**
   * Return the zero vector
   */
  zero: function zero() {
    return [0, 0, 0];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  linearInterpolate: function linearInterpolate(a, b, t) {
    var lerp = scalar.linearInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t), lerp(a[2], b[2], t)];
  },


  /**
   * Interpolate between vectors a and b for a factor of t
   * with a smooth, ease in, ease out type effect
   * @param {number} a the start value
   * @param {number} b the end value
   * @param {number} t the time parameter
   * @returns {number} the interpolated value
   */
  smoothInterpolate: function smoothInterpolate(a, b, t) {
    var lerp = scalar.smoothInterpolate;
    return [lerp(a[0], b[0], t), lerp(a[1], b[1], t), lerp(a[2], b[2], t)];
  },


  /**
   * Interpolate with keyframes, e.g.,
   * [
   *   {stop: 0.1, value: [0, 100]},
   *   {stop: 0.5, value: [100, 100]},
   *   {stop: 0.9, value: [100, 0]}
   * ]
   * @param {keyframe[]} keyframes a list of keyframes
   * @param {number} time the time nearest the keyframe stop
   * @param {'linear'|'smooth'} timing interpolation timing
   * @param {object} lib the interpolation library to use
   */
  keyframeInterpolate: function keyframeInterpolate(keyframes, time) {
    var timing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'linear';
    var lib = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : vector3d;

    return _keyframeInterpolate(keyframes, time, timing, lib);
  }
};

exports.util = util;
exports.search = search;
exports.scalar = scalar;
exports.vector2d = vector2d;
exports.vector3d = vector3d;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/vector-keyframes/index.js
// module id = 52
// module chunks = 0